/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { logger as log } from '@common/logger';
import { injectable } from 'inversify';
import { TAgent, getAgent } from './agent';
import { SignUpUserProps } from './plugins';

const is = require('is_js');

const SERVICE_NAME = 'SignUpPageService';

@injectable()
export class SignUpPageService {
  public agent: TAgent;
  private readonly loginRestAPI: string;
  private readonly headers: any;
  private readonly signerPK: string;
  private userEmail: string = '';
  static displayName = 'SignUpPageService';
  constructor(props: any = {}) {
    this.agent = getAgent();
    this.loginRestAPI = props?.loginRestAPI;
    this.headers = props?.headers;
    this.signerPK = props.signerPK;
  }

  public setUserEmail(email: string) {
    this.userEmail = email;
  }

  public getUserEmail() {
    return this.userEmail;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();
    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async registerUser(args: SignUpUserProps) {
    let _args = {
      ...args,
      apiURL: this.loginRestAPI,
      headers: this.headers,
    };
    const agent = getAgent();
    return await agent.registerUser(_args);
  }

  public async getPageContent() {
    let content: any = {};
    let compProps: any = null;

    // const agent = getAgent();
    // const { token, decoded } = await agent?.parseAndDecodeToken({
    //   signerPK: this.signerPK,
    // });
    // content = {
    //   ...content,
    //   initialData: {
    //     email: decoded?.email,
    //     firstName: decoded?.firstName,
    //     lastName: decoded?.lastName,
    //   },
    //   token: token,
    //   isPassword: decoded?.authType === "PASSWORD",
    // };
    return content;
  }
}
